import { Component, EventEmitter, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { NgxFileDropEntry, NgxFileDropModule } from 'ngx-file-drop';

@Component({
    selector: 'app-drag-drop',
    templateUrl: './drag-drop.component.html',
    styleUrls: ['./drag-drop.component.scss'],
    standalone: true,
    imports: [NgxFileDropModule, MatButton]
})
export class DragDropComponent {
  @Output() public handleFileUpload: EventEmitter<File> = new EventEmitter<File>();

  isDataInvalid = false;
  public files: NgxFileDropEntry[] = [];

  public dropped(files: NgxFileDropEntry[]) {
    if (files.length > 1) {
      this.isDataInvalid = true;
      return;
    }
    this.isDataInvalid = false;
    this.files = files;
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          this.handleFileUpload.emit(file);
        });
      }
    }
  }
}
